import Home from "./components/Home";
// import { BrowserRouter } from "react-router-dom";
// import { Route } from "react-router";

function App() {
  return (
    <div>
      <Home />
      {/* <BrowserRouter>
        <Route path="/" component={Home} />
      </BrowserRouter> */}
    </div>
  );
}

export default App;
